import React, { useContext, useState } from 'react';
import styled from 'styled-components';

import '../../../index.css';
import closeIcon from '../../../icons/ic-modal-close.svg';
import copyIcon from '../../../icons/ic-copy.svg';
import guideIcon from '../../../icons/ic-qmark-orange.png';
import GuideModal from '../../../components/GuideModal';
import ShopModeContext from '../../../contexts/ShopModeContext';

function SetContentsModal(props) {
  const { open, close, version, hash } = props;
  const [isHovered, setIsHovered] = useState(false);
  const [makeShopIsHovered, setMakeShopIsHovered] = useState(false);
  const { shopMode } = useContext(ShopModeContext);

  //console.log('hash', hash);

  const code = `<div id="wizmon-${hash}"></div>`;
  const mobileCode = `<div id="wizmonMobile-${hash}"></div>`;
  const scriptURL = `https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/wizmon-${
    version === 'pc' ? 'pc' : 'mobile'
  }.js`;

  return (
    <div className={open ? 'openModal modal' : 'modal'}>
      <Modal shopMode={shopMode}>
        <ModalHeader>
          <ModalTitle>콘텐츠 배치하기</ModalTitle>
          <CloseButton onClick={close}>
            <img src={closeIcon} alt="닫기" />
          </CloseButton>
        </ModalHeader>

        {shopMode === 'makeshop' && (
          <ModalContent>
            <SubTitle>
              아래 URL을 외부 스크립트 연동 페이지에 입력해 주세요.
            </SubTitle>
            <TextBox>
              <Text>{scriptURL}</Text>
            </TextBox>
            <MakeShopGuideDiv>
              {shopMode === 'makeshop' && (
                <GuideButton
                  shopMode={shopMode}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  style={{ position: 'relative' }}
                >
                  <img src={guideIcon} alt="가이드 보기 버튼" width={20} />
                  <GuideText isHovered={isHovered}>메이크샵 가이드</GuideText>
                  {isHovered && (
                    <GuideModal
                      videoLink=""
                      pdfLink="https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/guides/%E1%84%86%E1%85%A6%E1%84%8B%E1%85%B5%E1%84%8F%E1%85%B3%E1%84%89%E1%85%A3%E1%86%B8_%E1%84%8B%E1%85%AC%E1%84%87%E1%85%AE+%E1%84%89%E1%85%B3%E1%84%8F%E1%85%B3%E1%84%85%E1%85%B5%E1%86%B8%E1%84%90%E1%85%B3+%E1%84%8B%E1%85%A7%E1%86%AB%E1%84%83%E1%85%A9%E1%86%BC+%E1%84%80%E1%85%A1%E1%84%8B%E1%85%B5%E1%84%83%E1%85%B3.pdf"
                      style={{
                        position: 'absolute',
                        transform: 'translateX(60%) translateY(-10%)',
  
                      }}
                    />
                  )}
                </GuideButton>
              )}
              <CopyButton
                onClick={() => {
                  navigator.clipboard.writeText(scriptURL).then(() => {
                    alert('복사완료');
                  });
                }}
              >
                <img src={copyIcon} alt="복사하기 버튼" />
                복사하기
              </CopyButton>
            </MakeShopGuideDiv>
          </ModalContent>
        )}

        <ModalContent>
          <GuideDiv>
            <SubTitle>
              아래 코드를 쇼핑몰의 원하는 위치에 삽입해 주세요.
            </SubTitle>
            {shopMode === 'cafe24' && (
              <GuideButton
                shopMode={shopMode}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <img src={guideIcon} alt="가이드 보기 버튼" width={20} />
                <GuideText isHovered={isHovered}>가이드</GuideText>
                {isHovered && (
                  <GuideModal
                    videoLink="https://youtu.be/VasgPip9_CQ?si=5_YSu34Nl5I-oa96"
                    pdfLink="https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/guides/Enwise+_%E1%84%8F%E1%85%A9%E1%84%83%E1%85%B3%E1%84%89%E1%85%A1%E1%86%B8%E1%84%8B%E1%85%B5%E1%86%B8%E1%84%80%E1%85%A1%E1%84%8B%E1%85%B5%E1%84%83%E1%85%B3.pdf"
                  />
                )}
              </GuideButton>
            )}
          </GuideDiv>

          <TextBox>
            <Text>{version === 'pc' ? code : mobileCode}</Text>
          </TextBox>
          <MakeShopGuideDiv>
            {shopMode === 'makeshop' && (
              <GuideButton
                shopMode={shopMode}
                onMouseEnter={() => setMakeShopIsHovered(true)}
                onMouseLeave={() => setMakeShopIsHovered(false)}
                style={{ position: 'relative' }}
              >
                <img src={guideIcon} alt="가이드 보기 버튼" width={20} />
                <GuideText isHovered={makeShopIsHovered}>
                  메이크샵 가이드
                </GuideText>
                {makeShopIsHovered && (
                  <GuideModal
                    videoLink=""
                    pdfLink="https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/guides/%E1%84%86%E1%85%A6%E1%84%8B%E1%85%B5%E1%84%8F%E1%85%B3%E1%84%89%E1%85%A3%E1%86%B8_%E1%84%8F%E1%85%A9%E1%84%83%E1%85%B3%E1%84%89%E1%85%A1%E1%86%B8%E1%84%8B%E1%85%B5%E1%86%B8+%E1%84%80%E1%85%A1%E1%84%8B%E1%85%B5%E1%84%83%E1%85%B3.pdf"
                    style={{
                      position: 'absolute',
                      transform: 'translateX(60%) translateY(-10%)',

                    }}
                  />
                )}
              </GuideButton>
            )}
            <CopyButton
              onClick={() => {
                navigator.clipboard
                  .writeText(version === 'pc' ? code : mobileCode)
                  .then(() => {
                    alert('복사완료');
                  });
              }}
            >
              <img src={copyIcon} alt="복사하기 버튼" />
              복사하기
            </CopyButton>
          </MakeShopGuideDiv>
        </ModalContent>
        <CompleteButton onClick={close}>완료</CompleteButton>
      </Modal>
    </div>
  );
}

export default SetContentsModal;

const Modal = styled.div`
  width: 530px;
  height: ${(props) => (props.shopMode === 'cafe24' ? '424px' : '692px')};
  background-color: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  padding: 20px 30px 32px;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModalTitle = styled.div`
  font-size: 24px;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 42px;
`;

const SubTitle = styled.p`
  font-size: 18px;
  color: #4d4d4d;
`;

const TextBox = styled.div`
  border: 1px solid #c4c4c4;
  border-radius: 9px;
  background-color: #f8f8f8;
  height: 133px;
  padding: 20px 24px;
  margin: 20px 0 12px;
`;

const CloseButton = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
`;

const CompleteButton = styled.button`
  border-radius: 18px;
  background-color: #ffb600;
  color: #fff;
  padding: 6px 30px;
  font-size: 20px;
  font-weight: 700;
  width: fit-content;
  align-self: center;
  margin-top: auto;
`;

const CopyButton = styled.button`
  border: none;
  background-color: transparent;
  color: #848484;
  font-size: 16px;
  align-self: flex-end;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const GuideDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const MakeShopGuideDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const GuideButton = styled.button`
  border: none;
  background-color: transparent;
  color: #ff7a00;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  position: relative;
`;

const GuideText = styled.p`
  color: #ff7a00;
  font-size: 14px;
  cursor: pointer;
  text-decoration: ${(props) => (props.isHovered ? 'underline' : 'none')};
  line-height: ${(props) => (props.isHovered ? 'normal' : 'initial')};
  text-underline-position: under;
`;

const Text = styled.p`
  font-size: 19px;
  word-break: break-all;
`;
